import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {PatientExtended} from '@/features/patients/types'
import {useTranslation} from '@/translations/i18n'
import {getPatientServiceType} from '@/utilities/helpers'
import {useMemo} from 'react'
import {Text} from '@/components/ui/text/Text'

export const TreatmentRequestPatientPersonalData = ({patient}: {patient: PatientExtended}) => {
    const {t} = useTranslation()
    const yearsMonthsAge = useMemo(
        () => patient?.birthDate && getPatientServiceType(new Date(patient.birthDate)),
        [patient?.birthDate]
    )

    if (!patient.residenceAslDistrict || !patient.domicileAslDistrict) {
        return (
            <Text size="textSm" palette="neutral" shade="500">
                {t('errors:unavailable_asl')}
            </Text>
        )
    }

    return (
        <>
            <Text size="textMd" weight="500">
                {patient.fullName} (
                {yearsMonthsAge &&
                    (yearsMonthsAge.years > 0
                        ? `${t('commons:years_age', {count: yearsMonthsAge.years})}`
                        : yearsMonthsAge.months > 0 && `${t('commons:months_age', {count: yearsMonthsAge.months})}`)}
                )
            </Text>
            <Grid columns={2}>
                <GridItem spanColumn={1} direction="column">
                    <Text size="textSm" palette="neutral" shade="500">
                        {t('commons:residence_asl')}
                    </Text>
                    <Text size="textMd">
                        {patient.residenceAslDistrict.aslName} - {patient.residenceAslDistrict.name}
                    </Text>
                </GridItem>
                <GridItem spanColumn={1} direction="column">
                    <Text size="textSm" palette="neutral" shade="500">
                        {t('commons:domicile_asl')}
                    </Text>
                    <Text size="textMd">
                        {patient.domicileAslDistrict.id == patient.residenceAslDistrict.id
                            ? t('commons:same_as_residence')
                            : `${patient.domicileAslDistrict.aslName} - ${patient.domicileAslDistrict.name}`}
                    </Text>
                </GridItem>
            </Grid>
        </>
    )
}
